import Login from './Login.auth.vue'
import SignUp from './SignUp.auth.vue'
import ForgotPassword from './ForgotPassword.auth.vue'
import ResetLink from './ResetLink.auth.vue'

export default {
  Login, SignUp, ForgotPassword, ResetLink
}
